// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"cccb25f4","493":"0f74a6a9","571":"e43e3808","615":"d430d002","665":"7f83b7e0","721":"a4ce14e6","900":"1b007cd6"}[chunkId] + ".chunk.js";
};